import remeraBlanca from '../ropas/remeraBlanca.jpg';
import remeraCeleste from '../ropas/remeraCeleste.jpg';
import remeraRoja from '../ropas/remeraRoja.jpg';
import skatersGris from '../ropas/skatersGris.jpg';
import skatersLila from '../ropas/skatersLila.jpg';
import vintageGris from '../ropas/vintageGris.jpg';
import vintageVerde from '../ropas/vintageVerde.jpg';
import short1 from '../ropas/short1.jpg';




export const Data = [
    {
        id: 1,
        image: remeraBlanca,
        category: 'LISAS',
        talle:'S',
        precio: '$ 11300,30'
    },

    {
        id: 2,
        image: remeraCeleste,
        category: 'LISAS',
        talle:'S',
        precio: '$ 11500,40'
    },
    
    {
        id: 3,
        image: remeraRoja,
        category: 'LISAS',
        talle:'S',
        precio: '$ 12400'
    },

    {
        id: 4,
        image: skatersGris,
        category: 'SKATERS',
        talle:'S',
        precio: '$11000'
    },

    {
        id: 5,
        image: skatersLila,
        category: 'SKATERS',
        talle:'S',
        precio: '$ 10500,20'
    },

    {
        id: 6,
        image: vintageGris,
        category: 'VINTAGE',
        talle:'S',
        precio: '$ 11700,40'
    },

    {
        id: 7,
        image: vintageVerde,
        category: 'VINTAGE',
        talle:'S',
        precio: '$ 12800,10'
    },
    
    {
        id: 8,
        image: short1,
        category: 'SHORT',
        talle:'L',
        precio: '$ 13000'
    },
];